import { createAction, props } from '@ngrx/store';
import { IYear } from '../models/years.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadSendTaxCertificates = createAction(
  '[SendTaxCertificate] Load SendTaxCertificates',
  props<{ requestData: IYear; Id: string }>()
);

export const loadSendTaxCertificatesSuccess = createAction(
  '[SendTaxCertificate] Load SendTaxCertificates Success',
  props<{ response: string }>()
);

export const loadSendTaxCertificatesFailure = createAction(
  '[SendTaxCertificate] Load SendTaxCertificates Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
